"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledProfileActions = exports.StyledProfileActionsLink = void 0;
const theme_1 = require("@icr-ui/theme");
const styled_components_1 = __importDefault(require("styled-components"));
const general_1 = require("../../../general");
exports.StyledProfileActionsLink = (0, styled_components_1.default)(general_1.Typography) `
  padding: ${theme_1.spacings.s6} 0;
  width: 100%;
`;
exports.StyledProfileActions = styled_components_1.default.div `
  width: 100%;
`;
//# sourceMappingURL=styles.js.map